import React, { Component } from 'react'
import './index.scss'

export default class index extends Component {
  render() {
    return (
      <div className='notFound'>
        <div className='pic'></div>
        <div>
          <p className='title'>天呐～ </p>
          <p>您访问的页面被任意门带走啦</p>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/NotFound/index.js